import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useUserRole = () => {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkRole = async () => {
      // Wait for auth to complete first
      if (authLoading) {
        return;
      }

      if (!user) {
        console.log('useUserRole: No user found');
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      console.log('useUserRole: Checking role for user:', user.id);

      try {
        const { data, error } = await supabase.rpc('has_role', {
          _user_id: user.id,
          _role: 'admin',
        });

        if (error) {
          console.error('useUserRole: RPC error:', error);
          throw error;
        }
        
        console.log('useUserRole: has_role result:', data);
        setIsAdmin(data || false);
      } catch (error) {
        console.error('Error checking role:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkRole();
  }, [user, authLoading]);

  return { isAdmin, loading };
};
